import Phaser from "phaser";

//import { helper } from "./cGameObjects/helper";

import { cButton } from "./cGameObjects/cButton";
import { cTextSprite } from "./cGameObjects/cTextSprite";
import { cSprite } from "./cGameObjects/cSprite";
import { cScene } from "./cScene";
import { cObject } from "./cGameObjects/cObject";
import { cText } from "./cGameObjects/cText";
import { cContainer } from "./cGameObjects/cContainer";
import { ScreenItem } from "./dataTypes";
import { cInlineDisplay } from "./cGameObjects/cInlineDisplay";
import { cSpriteLoad } from "./cGameObjects/cSpriteLoad";
import { Character } from "./cDisplayObjects/Character";
import { Sticker } from "./cDisplayObjects/Sticker";
import { Landscape } from "./cDisplayObjects/Landscape";
import { Clouds } from "./cDisplayObjects/Clouds";
import { EvaluationCard } from "./cDisplayObjects/EvaluationCard";
import { stickerPoster } from "./cDisplayObjects/stickerPoster";
import { cScrollContainer } from "./cGameObjects/cScrollContainer";


export interface createParam {
  type: string,
  scene: Phaser.Scene
  data:ScreenItem[]
  onReady: Function
}

export class cDisplay extends Phaser.GameObjects.Container {

  public static _displayTypes: any = {}

  public static registerDisplayType = (name:string, cb:Function  )=>{
    cDisplay._displayTypes[ name ] = cb
  }

  public static DisplayTypeExists(name:String){
    return typeof this._displayTypes[name as any] !== 'undefined'
  }

  public static getDisplayTypeList():string[] {
    return Object.keys( cDisplay._displayTypes )
  }

  public static createDisplayType({...args}):cDisplay{
    if (typeof args.type == 'undefined'){
      console.error('No Scene Type specified')
    }else if(typeof cDisplay._displayTypes[args.type] == 'undefined'){
      console.error('Type specified does not exisis', args.type)    
    }else{
      return cDisplay._displayTypes[ args.type ].call(this,args)
    }
    return new cDisplay(args.scene, args.data, args.onReady)
  }


  private _data: ScreenItem[]
  protected reflist_id: any = {}
  protected namelist_id: any = {}
  protected animStartList: any = []
  protected animCloseList: any = []

  public events: Phaser.Events.EventEmitter; 

  static _gameObjectTypes:any = {}
  static registerObjectType(name:string, cb:Function){
    cDisplay._gameObjectTypes[name] = cb;
  }

  constructor(sc:Phaser.Scene,data:ScreenItem[] = [], onReady:Function){
    super(sc,0,0)
    this.events = new Phaser.Events.EventEmitter()
    this._data = data
    this.init();
    //var q = helper.getDisplayRect(this.scene)

    if (this._data.length > 0){
      this.buildScene();
      onReady();
    }
    setTimeout( ()=>{
      this.mounted();
    },2)
  }

  init(){
  }


  buildScene(){
    this._data.sort( (a:any,b:any)=>{
      if (a.depth < b.depth) return -1
      if (a.depth > b.depth) return 1
      return 0
    })
    
    this._data.forEach( (el:ScreenItem,i:number)=>{
      var gm:Phaser.GameObjects.GameObject | null = null

      if (el.debugOnly && !(this.scene as cScene).debugMode) return

      switch(el.type){
        case 'sprite': 
          gm = new cSprite(this.scene as cScene,el );             
          break;
        case 'textsprite': 
          gm = new cTextSprite(this.scene as cScene,el );             
          break;
        case 'spriteload':
          gm = new cSpriteLoad(this.scene as cScene,el);
          break;
        case 'character':
          gm = new Character(this.scene as cScene,el);
          break;
        case 'evaluationcard':
          gm = new  EvaluationCard(this.scene as cScene,el);
          break;
        case 'clouds':
          gm = new Clouds(this.scene as cScene,el);
          break;
        case 'landscape':
          gm = new Landscape (this.scene as cScene,el);
          break;
        case 'sticker':
          gm = new Sticker(this.scene as cScene,el);
          (gm as any).events.addListener('click', (e:any)=>{            
            this.events.emit('action','click', gm, el)
          });          
          break;
        case 'button': 
          gm = new cButton(this.scene as cScene,el );
          (gm as any).events.addListener('click', (e:any)=>{            
            this.events.emit('action','click', gm, el)
          });
          break;
        case 'stickerposter':
          gm = new stickerPoster(this.scene as cScene,el)
          break;
        case 'text':
          gm = new cText(this.scene as cScene,el)
          break;
        case 'container':
          gm = new cContainer(this.scene as cScene,el)
          break;
        case 'scrollcontainer':
          gm = new cScrollContainer(this.scene as cScene,el)
          break;
        case 'display':          
          gm = new cInlineDisplay(this.scene as cScene, el, ()=>{});
          (gm as any).events.addListener('click', (e:any)=>{            
            this.events.emit(e)
          });          
          break;
        default:
          if (cDisplay._gameObjectTypes[el.type]){
            gm = cDisplay._gameObjectTypes[el.type](this.scene as cScene,el)
          }else{
            gm = new cSprite(this.scene as cScene,el);
          }
      }      
      if (gm){
        (gm as any).depth = el.depth || i
        this.scene.add.existing(gm);
        if (el.debugHide && (this.scene as cScene).debugMode){
          (gm as Phaser.GameObjects.Sprite).visible = false;
        }

        if (el.target){
          var tg =  this.namelist_id[ el.target ] as any
          if (tg && tg.add){
            
            tg.add(gm)
          }else{
            console.warn('target not found')
          }          
        }else{          
          this.add(gm)
        }

        this.reflist_id[ el.id ] = gm
        this.namelist_id[ el.name ] = gm
      }
    })  
    this.sort('depth')
  }


  protected mounted(){

  }

  protected closed(){

  }


  public close(cb:Function){
    if (this.animCloseList.length === 0) {
      cb()
    }else{
      var lCount = this.animCloseList.length;
      this.animCloseList.forEach( (el:cObject ) => {
        el.close( ()=>{          
          lCount--
          if (lCount===0) {
            cb()
            this.closed();
            this.destroy(true)
          }
        })
      });
    }
  }


  public getById(id:string){    
    return this.reflist_id[ id ]
  }

  public getByName(id:string){
    return this.namelist_id[ id ]
  }


}
